export const CHIP_COLORS = {
  SUCCESS: {
    color: "green",
    backgroundColor: "#F0FFF099"

  },
  ERROR: {
    color: "red", 
    backgroundColor: "#FFF0F099"
  },
  WARNING: {
    color: "#ffffff",
    backgroundColor: "#ff9800"
  },
  INFO: {
    color: "#ffffff",
    backgroundColor: "#2196f3"
  },
  SECONDARY: {
    color: "#ffffff",
    backgroundColor: "#9e9e9e"
  }
} as const;

export type ChipColorType = keyof typeof CHIP_COLORS; 